import React from 'react';
import { message } from 'antd';
import Resizer from 'react-image-file-resizer';
import { Translation } from 'react-i18next';

const scrubFileName = fileName => !!fileName ? fileName?.replace(/[^\w\d_\-.]+/gi, '') : "";

const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

const normFile = e => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

const beforeUploadCheckSize = file => {
  const tempFile = new File([file], scrubFileName(file.name));
  const isLtM = file.size / 1024 / 1024 < 3;
  if (!isLtM) {
    <Translation>
      {(t, { i18n }) =>  message.error(t("errors.fileWrongSize3MB"))}
    </Translation>
  }
  return isLtM && tempFile;
};

const beforeUpload = file => {
  const tempFile = new File([file], scrubFileName(file?.name));
  const isJpgOrPng =
    file?.type === 'image/jpeg' ||
    file?.type === 'image/png' ||
    file?.type === 'image/bmp' ||
    file?.type === 'image/gif' ||
    file?.type === 'image/tiff' ||
    file?.type === 'image/webp';
  if (!isJpgOrPng) {
    <Translation>
      {
        (t, { i18n }) =>  message.error(t("errors.wrongTypeOfFile"))
      }
    </Translation>
  }
  const isLt2M = file?.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    <Translation>
      {
        (t, { i18n }) =>  message.error(t("errors.fileWrongSize10MB"))
      }
    </Translation>
  }
  return isJpgOrPng && isLt2M && tempFile;
};

const resizeFile = file =>
  new Promise(resolve => {
    if (file.name.includes('.tif') || file.name.includes('.tiff')) {
      resolve(file);
    } else {
      Resizer.imageFileResizer(
        file, // Is the file of the image which will resized.
        1920, // Is the maxWidth of the resized new image.
        1080, // Is the maxHeight of the resized new image.
        'JPEG', // Is the compressFormat of the resized new image.
        90, // Is the quality of the resized new image.
        0, // Is the degree of clockwise rotation to apply to uploaded image.
        // uri => {
        //   resolve(uri);
        // },
        async uri => {
          let name = file.name.toLowerCase().replace(/\s/g, '');
          name = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          let concatObject = await Object.assign(uri, {
            name: name,
            path: file.path,
            order: file.order,
            thumbUrl: file.thumbUrl,
            lastModified: file.lastModified,
            uid: file.uid,
            order: file.order,
          });
          resolve(concatObject);
        },
        'blob',
      );
    }
  });

export {
  getBase64,
  normFile,
  beforeUploadCheckSize,
  beforeUpload,
  resizeFile,
  scrubFileName,
};
